import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import LazyImg from '@/components/base/LazyImg';
import Dialog from '@/components/base/Dialog';
import Linker from '@/components/base/Linker';
import NFTList from '@/components/combined/NFTList';
import Skeleton from 'react-loading-skeleton';
import AddressText from '../AddressText';
import { gettext } from '@/utils/langsBook';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import styled, { css } from 'styled-components';
import { makeAddressInfo, makeShardDetailLink, makeAddressTokens, makeAddressManageTokens, makeAddressTxns, makeAddressContracts, makeAddressManageDApps, makeDAppContracts, makeDAppContract } from '@/utils/link';
import { toID, toDio, toShardCount, toShard, toCoinAge, toUTCTime, prettyNumber, toToken, toNFTID } from '@/utils/string';
import { ADDRESS_TYPE, SOCIAL } from '@/constants/Address';
import { TXN_TYPE_ISSUED } from '@/constants/Transaction';
import getOverviewService from '@/api/overview';
import refreshStore from '@/store/Refresh';
import { observer } from 'mobx-react-lite';
import { address as addressTool } from '@dioxide-js/misc';
import clss from 'classnames';
import Tooltip from '@/components/base/Tooltip';
import { DEFAULT } from '@/constants';
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var overviewService = getOverviewService();
var AddressItemStyled = css([
    ".label{",
    "}.value{",
    " .social{&:not(:last-child){margin-right:20px;}img{width:32px;height:32px;}}}"
], {
    "width": "200px",
    "color": "var(--color-text-secondary)",
    "fontSize": "16px",
    "lineHeight": "20px"
}, {
    "fontSize": "16px",
    "flex": "1 1 0%",
    "flexWrap": "wrap",
    "lineHeight": "20px",
    "minHeight": "20px",
    "display": "flex",
    "justifyContent": "flex-start",
    "alignItems": "center"
});
var AddressBaseInfoGroup = styled.div.withConfig({
    displayName: "AddressInfo__AddressBaseInfoGroup",
    componentId: "sc-1emk6ax-0"
})([
    "",
    " &.token,&.dapp,&.nft{",
    "}&.user{grid-template-rows:repeat(6,1fr);grid-template-columns:1fr 464px;}.desc-box{",
    " ",
    "}"
], {
    "borderRadius": "8px",
    "backgroundColor": "var(--color-box-bg)",
    "paddingTop": "40px",
    "paddingBottom": "40px",
    "paddingLeft": "56px",
    "paddingRight": "56px",
    "width": "100%",
    "display": "grid",
    "gridAutoFlow": "column",
    "gridTemplateRows": "repeat(5, minmax(0, 1fr))",
    "gap": "24px"
}, {
    "gridAutoFlow": "row",
    "gridTemplateRows": "repeat(2, minmax(0, 1fr))"
}, {
    "display": "inline-flex",
    "alignItems": "center",
    "width": "100%"
}, AddressItemStyled);
var AddressBaseInfoItem = styled.div.withConfig({
    displayName: "AddressInfo__AddressBaseInfoItem",
    componentId: "sc-1emk6ax-1"
})([
    "",
    " &:not(:last-child){margin-bottom:24px;}",
    ""
], {
    "display": "inline-flex",
    "alignItems": "flex-start",
    "width": "100%"
}, AddressItemStyled);
var AddressInfoDesc = styled.div.withConfig({
    displayName: "AddressInfo__AddressInfoDesc",
    componentId: "sc-1emk6ax-2"
})([
    "",
    " .value{max-width:664px;}"
], {
    "paddingLeft": "56px",
    "alignSelf": "flex-start",
    "width": "920px"
});
var AddressInfoItem = function(props) {
    return(/*#__PURE__*/ _jsxs(AddressBaseInfoItem, {
        children: [
            /*#__PURE__*/ _jsxs("span", {
                className: "label",
                children: [
                    gettext(props.label),
                    ":"
                ]
            }),
            /*#__PURE__*/ _jsx("span", {
                className: "value",
                children: props.loading || props.value
            })
        ]
    }));
};
var AddressInfo = function(props) {
    var ref8, ref1, ref2, ref3;
    var ref4 = useState(''), clampDesc = ref4[0], setClampDesc = ref4[1];
    var ref5 = useState(0), shardOrder = ref5[0], setShardOrder = ref5[1];
    var moreRef = useRef(null);
    var ref6 = props || {}, target = ref6.target, Metadata1 = ref6.Metadata, ShardIndex = ref6.ShardIndex;
    var refresh = refreshStore.refresh;
    var ref7 = useMemo(function() {
        var ref = _slicedToArray(target.split(':'), 2), address = ref[0], tmp = ref[1], type = tmp === void 0 ? 'ed25519' : tmp;
        return [
            address,
            type
        ];
    }, [
        target
    ]), address1 = ref7[0], type1 = ref7[1];
    useEffect(function() {
        var desc = Metadata1 === null || Metadata1 === void 0 ? void 0 : Metadata1.Description;
        var t = setTimeout(function() {
            if (moreRef.current && desc && !props.loading) {
                var height = ((moreRef === null || moreRef === void 0 ? void 0 : moreRef.current.getClientRects()[0]) || {}).height;
                var overHeight = height - 72;
                if (overHeight > 0) {
                    var ref;
                    var originTextLen = ((ref = moreRef.current.textContent) === null || ref === void 0 ? void 0 : ref.length) || 0;
                    var gap = overHeight > 24 ? overHeight * 8 / 24 : overHeight / 8;
                    var finalStr = desc.substr(0, originTextLen - gap);
                    if (overHeight <= 72) {
                        setClampDesc(finalStr.substr(0, originTextLen - 8) + '...');
                    } else {
                        setClampDesc(finalStr);
                    }
                }
            }
        }, 5);
        return function() {
            clearTimeout(t);
        };
    }, [
        moreRef.current,
        Metadata1 === null || Metadata1 === void 0 ? void 0 : Metadata1.Description,
        clampDesc,
        props.loading
    ]);
    useEffect(function() {
        overviewService.getOverview().then(function(res) {
            if (res === null || res === void 0 ? void 0 : res.Result) {
                var ref;
                setShardOrder(res === null || res === void 0 ? void 0 : (ref = res.Result) === null || ref === void 0 ? void 0 : ref.ShardOrder);
            }
        });
    }, [
        refresh
    ]);
    var handleDescModel = useCallback(function() {
        if (Metadata1 === null || Metadata1 === void 0 ? void 0 : Metadata1.Description) {
            Dialog.alert({
                hideTitle: true,
                width: 596,
                info: function() {
                    /*#__PURE__*/ return _jsx("p", {
                        className: "break-words text-secondary text-[16px] leading-[32px] max-h-[232px] overflow-y-auto",
                        children: Metadata1 === null || Metadata1 === void 0 ? void 0 : Metadata1.Description
                    });
                },
                clickWrappHide: true
            });
        }
    }, [
        Metadata1
    ]);
    var isToken = useMemo(function() {
        return type1 === ADDRESS_TYPE.token;
    }, [
        type1
    ]);
    var isDApp = useMemo(function() {
        return type1 === ADDRESS_TYPE.dapp;
    }, [
        type1
    ]);
    var isNFT = useMemo(function() {
        return type1 === ADDRESS_TYPE.nft;
    }, [
        type1
    ]);
    var isUser = useMemo(function() {
        return type1 === ADDRESS_TYPE.ed25519;
    }, [
        type1
    ]);
    var renderLoading = useMemo(function() {
        return (props === null || props === void 0 ? void 0 : props.loading) ? /*#__PURE__*/ _jsx(Skeleton, {
            width: 200,
            height: 15
        }) : 0;
    }, [
        props
    ]);
    var renderTitle = useMemo(function() {
        switch(type1){
            case ADDRESS_TYPE.token:
            case ADDRESS_TYPE.dapp:
                var ref;
                return props === null || props === void 0 ? void 0 : (ref = props.target) === null || ref === void 0 ? void 0 : ref.split(':')[0];
            case ADDRESS_TYPE.nft:
                var ref9;
                return props === null || props === void 0 ? void 0 : (ref9 = props.Definition) === null || ref9 === void 0 ? void 0 : ref9.name;
            default:
                var ref10;
                return (props === null || props === void 0 ? void 0 : (ref10 = props.Metadata) === null || ref10 === void 0 ? void 0 : ref10.Name) || '';
        }
    }, [
        props,
        type1
    ]);
    var renderID = useMemo(function() {
        var ref;
        if (type1 === ADDRESS_TYPE.ed25519) return '';
        var series = props === null || props === void 0 ? void 0 : (ref = props.Definition) === null || ref === void 0 ? void 0 : ref.series;
        return(/*#__PURE__*/ _jsx(AddressInfoItem, {
            label: "ID",
            loading: renderLoading,
            value: ((props === null || props === void 0 ? void 0 : props.BaseID) ? toNFTID(0, props === null || props === void 0 ? void 0 : props.BaseID, _instanceof(series, Array) ? series.length : series) : toID(props === null || props === void 0 ? void 0 : props.ID)) || toID(props === null || props === void 0 ? void 0 : props.TokenCVID) || '--'
        }));
    }, [
        props,
        renderLoading
    ]);
    var renderDelegate = useMemo(function() {
        if ([
            DEFAULT.TOKEN,
            'core'
        ].includes((props === null || props === void 0 ? void 0 : props.Symbol) || '')) return '';
        var delegator = (props === null || props === void 0 ? void 0 : props.Delegator) || '';
        if (!delegator || !delegator.match(':')) return '';
        return(/*#__PURE__*/ _jsx(AddressInfoItem, {
            label: "Delegator",
            loading: renderLoading,
            value: /*#__PURE__*/ _jsx(AddressText, {
                href: makeAddressInfo(delegator),
                showAvatar: false,
                address: delegator,
                copyable: true
            })
        }));
    }, [
        props,
        renderLoading
    ]);
    var renderTokenInfo = useMemo(function() {
        var ref13, ref11, ref12;
        if (!isToken) return '';
        return(/*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(AddressInfoItem, {
                    label: "Max Total Supply",
                    loading: renderLoading,
                    value: toToken({
                        value: props === null || props === void 0 ? void 0 : props.TotalSupply,
                        symbol: (props === null || props === void 0 ? void 0 : props.Symbol) || address1,
                        decimals: props === null || props === void 0 ? void 0 : props.Decimals
                    })
                }),
                renderDelegate,
                /*#__PURE__*/ _jsx(AddressInfoItem, {
                    label: "Decimals",
                    loading: renderLoading,
                    value: (props === null || props === void 0 ? void 0 : props.Decimals) || 0
                }),
                /*#__PURE__*/ _jsx(AddressInfoItem, {
                    label: "Minter",
                    loading: renderLoading,
                    value: /*#__PURE__*/ _jsx(_Fragment, {
                        children: (props === null || props === void 0 ? void 0 : props.TokenMinters) ? props === null || props === void 0 ? void 0 : (ref13 = props.TokenMinters) === null || ref13 === void 0 ? void 0 : ref13.map(function(t) {
                            var ref = _slicedToArray(t.Contract.split('.'), 1), dapp = ref[0];
                            return(/*#__PURE__*/ _jsxs(Linker, {
                                className: "leading-[30px]",
                                href: makeDAppContract(dapp + ':dapp', t.Contract),
                                children: [
                                    t.Contract,
                                    " "
                                ]
                            }, t.Contract));
                        }) : '--'
                    })
                }),
                /*#__PURE__*/ _jsx(AddressInfoItem, {
                    label: "Token Balance",
                    loading: renderLoading,
                    value: toToken({
                        value: ((ref12 = props === null || props === void 0 ? void 0 : (ref11 = props.Wallet) === null || ref11 === void 0 ? void 0 : ref11.find(function(w) {
                            return w.symbol === (props === null || props === void 0 ? void 0 : props.Symbol);
                        })) === null || ref12 === void 0 ? void 0 : ref12.amount) || 0,
                        decimals: props === null || props === void 0 ? void 0 : props.Decimals,
                        symbol: props === null || props === void 0 ? void 0 : props.Symbol
                    })
                })
            ]
        }));
    }, [
        props,
        renderDelegate,
        renderLoading,
        isToken
    ]);
    var renderNFTInfo = useMemo(function() {
        var ref, ref14, ref15, ref16, ref17, ref18, ref19;
        if (!isNFT) return '';
        var entityBaseUrl = (props === null || props === void 0 ? void 0 : (ref = props.Metadata) === null || ref === void 0 ? void 0 : (ref14 = ref.Social) === null || ref14 === void 0 ? void 0 : ref14.EntityBaseUrl) || '';
        var entityUrl = entityBaseUrl + (props === null || props === void 0 ? void 0 : (ref15 = props.Definition) === null || ref15 === void 0 ? void 0 : ref15.hash);
        return(/*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                renderID,
                /*#__PURE__*/ _jsx(AddressInfoItem, {
                    label: "Authorship",
                    loading: renderLoading,
                    value: !(props === null || props === void 0 ? void 0 : (ref16 = props.Definition) === null || ref16 === void 0 ? void 0 : ref16.signer) ? '--' : /*#__PURE__*/ _jsx(AddressText, {
                        href: makeAddressInfo(props === null || props === void 0 ? void 0 : (ref17 = props.Definition) === null || ref17 === void 0 ? void 0 : ref17.signer),
                        showAvatar: false,
                        address: props === null || props === void 0 ? void 0 : (ref18 = props.Definition) === null || ref18 === void 0 ? void 0 : ref18.signer,
                        copyable: true
                    })
                }),
                /*#__PURE__*/ _jsx(AddressInfoItem, {
                    label: "Signed Date",
                    loading: renderLoading,
                    value: toUTCTime(props === null || props === void 0 ? void 0 : props.SignedDate)
                }),
                renderDelegate,
                /*#__PURE__*/ _jsx(AddressInfoItem, {
                    label: "Cover Artwork",
                    loading: renderLoading,
                    value: /*#__PURE__*/ _jsx("span", {
                        className: "font-mono",
                        children: (props === null || props === void 0 ? void 0 : (ref19 = props.Definition) === null || ref19 === void 0 ? void 0 : ref19.hash) || '--'
                    })
                }),
                /*#__PURE__*/ _jsx(AddressInfoItem, {
                    label: "EntityURL",
                    loading: renderLoading,
                    value: !entityBaseUrl ? '--' : /*#__PURE__*/ _jsx("a", {
                        className: "line-clamp text-primary",
                        href: entityUrl,
                        target: "_blank",
                        rel: "noreferrer",
                        children: entityUrl
                    })
                })
            ]
        }));
    }, [
        renderID,
        renderDelegate,
        props,
        isNFT
    ]);
    var renderDAppInfo = useMemo(function() {
        if (!isDApp) return '';
        return(/*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(AddressInfoItem, {
                    label: "DApp ID",
                    loading: renderLoading,
                    value: toID(props === null || props === void 0 ? void 0 : props.ID) || '--'
                }),
                /*#__PURE__*/ _jsx(AddressInfoItem, {
                    label: "Managed Contracts",
                    loading: renderLoading,
                    value: /*#__PURE__*/ _jsx(Linker, {
                        href: makeDAppContracts(target),
                        text: (props.HeldContract || 0).toString()
                    })
                }),
                renderDelegate
            ]
        }));
    }, [
        renderID,
        renderDelegate,
        renderLoading,
        isDApp,
        target
    ]);
    var renderWebsiteAndSocial = useMemo(function() {
        var ref21 = props || {}, Metadata = ref21.Metadata, loading = ref21.loading;
        var website = Metadata === null || Metadata === void 0 ? void 0 : Metadata.Website;
        var filterSocial = {
            Github: '',
            Discord: '',
            Twitter: '',
            Telegram: '',
            Facebook: '',
            Email: ''
        };
        Object.keys((Metadata === null || Metadata === void 0 ? void 0 : Metadata.Social) || {}).forEach(function(k) {
            var ref;
            var t = k;
            if (![
                'EntityBaseUrl',
                'ArtworkBaseUrl'
            ].includes(k) && (Metadata === null || Metadata === void 0 ? void 0 : (ref = Metadata.Social) === null || ref === void 0 ? void 0 : ref[t])) {
                var ref20;
                filterSocial[t] = Metadata === null || Metadata === void 0 ? void 0 : (ref20 = Metadata.Social) === null || ref20 === void 0 ? void 0 : ref20[t];
            }
        });
        return(/*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(AddressInfoItem, {
                    label: "Website",
                    loading: renderLoading,
                    value: website ? /*#__PURE__*/ _jsx("a", {
                        href: website.match('http') ? website : "https://".concat(website),
                        className: "text-primary line-clamp w-full",
                        target: "_blank",
                        rel: "noreferrer",
                        children: website
                    }) : '--'
                }),
                /*#__PURE__*/ _jsx(AddressInfoItem, {
                    label: "Social",
                    value: loading ? /*#__PURE__*/ _jsx(Skeleton, {
                        width: 32,
                        height: 32
                    }) : filterSocial && (Object.values(filterSocial) || []).filter(function(v) {
                        return v;
                    }).length ? Object.keys(filterSocial).map(function(s) {
                        var key = s.toLocaleLowerCase();
                        var url = filterSocial === null || filterSocial === void 0 ? void 0 : filterSocial[s];
                        if (!url || !SOCIAL[key]) return '';
                        return(/*#__PURE__*/ _jsx("a", {
                            className: "social",
                            href: key === SOCIAL.email ? "mailto:".concat(url) : url.match('http') ? url : "https://".concat(url),
                            target: "_blank",
                            rel: "noreferrer",
                            children: /*#__PURE__*/ _jsx("img", {
                                src: "/img/".concat(key, ".png"),
                                alt: key
                            })
                        }, key));
                    }) : '--'
                })
            ]
        }));
    }, [
        props
    ]);
    var renderDescription = useMemo(function() {
        return(/*#__PURE__*/ _jsx(AddressInfoItem, {
            label: "Description",
            loading: renderLoading,
            value: (Metadata1 === null || Metadata1 === void 0 ? void 0 : Metadata1.Description) ? /*#__PURE__*/ _jsxs("div", {
                className: "w-full max-h-[72px] break-all text-[16px] leading-[24px] text-desc relative overflow-hidden text-left",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "absolute -z-10 w-full break-words h-[100%] overflow-hidden",
                        children: Metadata1 === null || Metadata1 === void 0 ? void 0 : Metadata1.Description
                    }),
                    /*#__PURE__*/ _jsxs("span", {
                        className: "inline-block text-inherit",
                        ref: moreRef,
                        children: [
                            clampDesc ? clampDesc : Metadata1 === null || Metadata1 === void 0 ? void 0 : Metadata1.Description,
                            clampDesc && /*#__PURE__*/ _jsx("span", {
                                className: "text-primary cursor-pointer",
                                onClick: handleDescModel,
                                children: gettext('More')
                            })
                        ]
                    }, target)
                ]
            }) : '--'
        }));
    }, [
        props,
        Metadata1,
        clampDesc
    ]);
    var addressDefaultImgOpt = useMemo(function() {
        switch(type1){
            case ADDRESS_TYPE.token:
                return {
                    defaultUrl: DEFAULT.TOKEN_ICON
                };
            case ADDRESS_TYPE.nft:
                return {
                    defaultUrl: DEFAULT.NFT_ICON
                };
            case ADDRESS_TYPE.dapp:
                return {
                    defaultUrl: DEFAULT.DAPP_ICON
                };
            default:
                return {
                    defaultUrl: DEFAULT.ADDRESS_ICON
                };
        }
    }, [
        type1
    ]);
    var renderShard = useMemo(function() {
        try {
            var shard = ShardIndex || (target ? addressTool.addressToShard(target, shardOrder) : 0);
            return {
                label: 'Shard',
                render: function() {
                    if (renderLoading) return renderLoading;
                    return(/*#__PURE__*/ _jsxs("div", {
                        className: "flex items-center",
                        children: [
                            shard !== undefined && /*#__PURE__*/ _jsx(Linker, {
                                href: makeShardDetailLink(shard),
                                text: toShard(shard)
                            }),
                            "(".concat(gettext('Total:')).concat(toShardCount(shardOrder), ")")
                        ]
                    }));
                }
            };
        } catch (e) {
            console.log(e);
            return undefined;
        }
    }, [
        shardOrder,
        target,
        ShardIndex,
        renderLoading
    ]);
    var renderNFTTokenDApp = useMemo(function() {
        var ref = props || {}, Vault = ref.Vault, Wallet = ref.Wallet, _Balance = ref.Balance, Balance = _Balance === void 0 ? 0 : _Balance, _TotalNftManaged = ref.TotalNftManaged, TotalNftManaged = _TotalNftManaged === void 0 ? 0 : _TotalNftManaged, _TotalNftComposed = ref.TotalNftComposed, TotalNftComposed = _TotalNftComposed === void 0 ? 0 : _TotalNftComposed, _TotalTokenManaged = ref.TotalTokenManaged, TotalTokenManaged = _TotalTokenManaged === void 0 ? 0 : _TotalTokenManaged, _TotalDappManaged = ref.TotalDappManaged, TotalDappManaged = _TotalDappManaged === void 0 ? 0 : _TotalDappManaged, _NftHeld = ref.NftHeld, NftHeld = _NftHeld === void 0 ? 0 : _NftHeld;
        var tokenHeld = {
            label: 'Token Held',
            render: function() {
                if (renderLoading) return renderLoading;
                return(/*#__PURE__*/ _jsxs(Linker, {
                    href: makeAddressTokens(target),
                    children: [
                        Object.keys(Wallet || {}).length,
                        " Tokens"
                    ]
                }));
            }
        }; // const nftHeld = {
        //   label: 'NFT Held',
        //   render: () => {
        //     if (renderLoading) return renderLoading
        //     return <Linker href={makeAddressHeldNFTs(target)}>{NftHeld} NFTs</Linker>
        //   },
        // }
        if (isUser) {
            return [
                tokenHeld,
                {
                    label: 'Token Managed',
                    render: function() {
                        if (renderLoading) return renderLoading;
                        return(/*#__PURE__*/ _jsxs(Linker, {
                            href: makeAddressManageTokens(target),
                            children: [
                                TotalTokenManaged,
                                " Tokens"
                            ]
                        }));
                    }
                },
                // {
                //   label: 'NFT Managed',
                //   render: () => {
                //     if (renderLoading) return renderLoading
                //     return <Linker href={makeAddressManageNFTs(target)}>{TotalNftManaged} NFTs</Linker>
                //   },
                // },
                // {
                //   label: 'NFT Composed',
                //   render: () => {
                //     if (renderLoading) return renderLoading
                //     return <Linker href={makeAddressComposedNFTs(target)}>{TotalNftComposed} NFTs</Linker>
                //   },
                // },
                {
                    label: 'DApp Managed',
                    render: function() {
                        if (renderLoading) return renderLoading;
                        return(/*#__PURE__*/ _jsxs(Linker, {
                            href: makeAddressManageDApps(target),
                            children: [
                                TotalDappManaged,
                                " DApps"
                            ]
                        }));
                    }
                }
            ];
        } else {
            return [
                tokenHeld
            ];
        }
    }, [
        target,
        props,
        renderLoading
    ]);
    var baseInfoList = useMemo(function() {
        var ref = props || {}, _TotalTxn = ref.TotalTxn, TotalTxn = _TotalTxn === void 0 ? 0 : _TotalTxn, _TotalContract = ref.TotalContract, TotalContract = _TotalContract === void 0 ? 0 : _TotalContract, CoinAge = ref.CoinAge, _Balance = ref.Balance, Balance = _Balance === void 0 ? 0 : _Balance, _TotalIssuedTxn = ref.TotalIssuedTxn, TotalIssuedTxn = _TotalIssuedTxn === void 0 ? 0 : _TotalIssuedTxn, FirstSeen = ref.FirstSeen, LastSeen = ref.LastSeen;
        return [
            {
                label: 'Balance',
                render: function() {
                    return renderLoading || toDio(Balance, true);
                }
            }
        ].concat(_toConsumableArray(renderNFTTokenDApp), [
            {
                label: 'Contracts',
                render: function() {
                    return renderLoading || /*#__PURE__*/ _jsx(Linker, {
                        href: makeAddressContracts(target),
                        children: TotalContract
                    });
                }
            },
            renderShard,
            {
                label: 'Total Transactions',
                render: function() {
                    return renderLoading || /*#__PURE__*/ _jsx(Linker, {
                        href: makeAddressTxns(target),
                        children: prettyNumber(TotalTxn)
                    });
                }
            },
            {
                label: 'Issued Transactions',
                render: function() {
                    if (renderLoading) return renderLoading;
                    return(/*#__PURE__*/ _jsx(Linker, {
                        href: makeAddressTxns(target, {
                            type: TXN_TYPE_ISSUED
                        }),
                        children: prettyNumber(TotalIssuedTxn)
                    }));
                }
            },
            {
                label: 'First Issued',
                render: function() {
                    return renderLoading || FirstSeen ? toUTCTime(FirstSeen) : '--';
                }
            },
            {
                label: 'Last Issued',
                render: function() {
                    return renderLoading || LastSeen ? toUTCTime(LastSeen) : '--';
                }
            },
            {
                label: 'Credibility',
                render: function() {
                    return renderLoading || toCoinAge(CoinAge || 0);
                }
            }
        ]);
    }, [
        props,
        renderShard,
        renderLoading,
        renderNFTTokenDApp
    ]);
    var addressImg = isNFT ? ((Metadata1 === null || Metadata1 === void 0 ? void 0 : (ref8 = Metadata1.Social) === null || ref8 === void 0 ? void 0 : ref8.ArtworkBaseUrl) || '') + (props === null || props === void 0 ? void 0 : (ref1 = props.Definition) === null || ref1 === void 0 ? void 0 : ref1.hash) : props === null || props === void 0 ? void 0 : (ref2 = props.Metadata) === null || ref2 === void 0 ? void 0 : ref2.IconUrl;
    return(/*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "rounded-[8px] py-[40px] flex items-center relative bg-box",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "w-[264px] flex flex-col px-[42px] items-center",
                        children: [
                            (props === null || props === void 0 ? void 0 : props.loading) ? /*#__PURE__*/ _jsx(Skeleton, {
                                width: 120,
                                height: 120
                            }) : /*#__PURE__*/ _jsx(LazyImg, _objectSpread({
                                className: isNFT ? 'w-[200px] h-[140px] rounded-[10px]' : 'w-[120px] h-[120px] rounded-full',
                                url: addressImg,
                                alt: "address"
                            }, addressDefaultImgOpt), props === null || props === void 0 ? void 0 : props.target),
                            (props === null || props === void 0 ? void 0 : props.loading) ? /*#__PURE__*/ _jsx(Skeleton, {
                                className: "my-[20px]",
                                width: 100,
                                height: 24
                            }) : renderTitle && /*#__PURE__*/ _jsx(Tooltip, {
                                className: "w-full",
                                placement: "bottom",
                                overlay: renderTitle,
                                children: /*#__PURE__*/ _jsx("p", {
                                    className: "text-[24px] leading-[29px] font-[500] my-[20px] w-full line-clamp break-words text-center",
                                    children: renderTitle
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "h-[calc(100%-80px)] w-[1px] bg-[#E5E6EB] absolute top-[40px] left-[264px]"
                    }),
                    /*#__PURE__*/ _jsxs(AddressInfoDesc, {
                        children: [
                            renderWebsiteAndSocial,
                            renderDescription
                        ]
                    })
                ]
            }),
            isToken ? /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("p", {
                        className: "mt-[32px] mb-[12px] text-[18px] font-inter-semibold",
                        children: gettext('Token Info')
                    }),
                    /*#__PURE__*/ _jsx(AddressBaseInfoGroup, {
                        className: "token",
                        children: renderTokenInfo
                    })
                ]
            }) : null,
            isDApp ? /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("p", {
                        className: "mt-[32px] mb-[12px] text-[18px] font-inter-semibold",
                        children: gettext('DApp Info')
                    }),
                    /*#__PURE__*/ _jsx(AddressBaseInfoGroup, {
                        className: "dapp",
                        children: renderDAppInfo
                    })
                ]
            }) : null,
            isNFT ? /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("p", {
                        className: "mt-[32px] mb-[12px] text-[18px] font-inter-semibold",
                        children: gettext('NFT Info')
                    }),
                    /*#__PURE__*/ _jsx(AddressBaseInfoGroup, {
                        className: "nft",
                        children: renderNFTInfo
                    })
                ]
            }) : null,
            /*#__PURE__*/ _jsx("p", {
                className: "mt-[32px] mb-[12px] text-[18px] font-inter-semibold",
                children: gettext('Basic Info')
            }),
            /*#__PURE__*/ _jsx(AddressBaseInfoGroup, {
                className: clss({
                    user: isUser
                }),
                children: baseInfoList.map(function(i) {
                    return i ? /*#__PURE__*/ _jsxs("div", {
                        className: "desc-box",
                        children: [
                            /*#__PURE__*/ _jsxs("span", {
                                className: "label",
                                children: [
                                    gettext(i.label),
                                    ":"
                                ]
                            }),
                            /*#__PURE__*/ _jsx("span", {
                                className: "value whitespace-nowrap !max-w-[calc(100%_-_200px)] overflow-hidden",
                                children: i.render()
                            })
                        ]
                    }, i.label) : null;
                })
            }),
            isNFT && _instanceof(props === null || props === void 0 ? void 0 : (ref3 = props.Definition) === null || ref3 === void 0 ? void 0 : ref3.series, Array) && /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("p", {
                        className: "mt-[32px] mb-[12px] text-base font-[18px] font-[600] leading-[21px]",
                        children: gettext('NFT Combination Detail')
                    }),
                    /*#__PURE__*/ _jsx(NFTList, {
                        address: target,
                        BaseID: props === null || props === void 0 ? void 0 : props.BaseID
                    })
                ]
            })
        ]
    }));
};
export default observer(AddressInfo);
